<tilby-dialog-toolbar
    [title]="data.title|| 'Title'"
    [customActions]="customActions"
>
</tilby-dialog-toolbar>
<tilby-dialog-content>
    <div class="tw-select-text tw-max-w-screen-sm">
        <ngx-json-viewer [json]="dataObj"></ngx-json-viewer>
    </div>
</tilby-dialog-content>
